import { tableAnatomy } from "@chakra-ui/anatomy";
import {
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
  TableProps,
  TableHeadProps,
  TableBodyProps,
  TableFooterProps,
  TableRowProps,
  TableCellProps,
  TableColumnHeaderProps,
  TableCaptionProps,
  TableContainerProps,
  createMultiStyleConfigHelpers
} from "@chakra-ui/react";

const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers(tableAnatomy.keys);

const baseStyle = definePartsStyle({
  th: {
    fontSize: "xs",
    textTransform: "capitalize"
  },
  td: {
    fontSize: "xs",
    wordBreak: "break-all"
  }
});

const TableComponentStyle = defineMultiStyleConfig({
  baseStyle
});

export {
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
  TableComponentStyle
};

export type {
  TableProps,
  TableHeadProps,
  TableBodyProps,
  TableFooterProps,
  TableRowProps,
  TableCellProps,
  TableColumnHeaderProps,
  TableCaptionProps,
  TableContainerProps
};
